<template>
  <div>
    <b-jumbotron>
        <template #header>SMS Gateway</template>

        <template #lead>
          SMS Gatway for Swisscom Large Account
        </template>

        <hr class="my-4">

        <b-button class="m-3" variant="primary" href="/ui/list">List all messages</b-button>
        <b-button class="m-3" variant="success" href="/ui/send">Send SMS</b-button>

        <b-row class="text-left mt-4">
          <b-col>
            <b-card>
              <pre><code>
# send sms
curl -X POST  -H "Token: {{ token }}" \
{{ base_url }}/api/send \
-d '{ "sender":"Sender", "text": "Text text", "destination": "+41760000000", "retention": 7 }'
              </code></pre>
            </b-card>
          </b-col>
        </b-row>

        <b-row class="text-left mt-4">
          <b-col>
            <b-card>
              <pre><code>
# list all sms
curl  -H "Token: {{ token }}" {{ base_url}}/api/list
              </code></pre>
            </b-card>
          </b-col>
        </b-row>

        <b-row class="text-left mt-4">
          <b-col>
            <b-card>
              <pre><code>
# list specific message
curl  -H "Token: {{ token }}" {{ base_url }}/api/list/71f6a9a224fb465383b64ddd84ef9bf
              </code></pre>
            </b-card>
          </b-col>
        </b-row>

        <b-row class="text-left mt-4">
          <b-col>
            <b-card>
              <pre><code>
# get statistics for a user
curl  -H "Token: {{ token }}" {{ base_url }}/api/stats/user/year/month
              </code></pre>
            </b-card>
          </b-col>
        </b-row>
    </b-jumbotron>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: { },
  data: () => ({
    token: null,
    base_url: null
  }),
  mounted () {
    this.token = sessionStorage.getItem('token')
    this.base_url = window.location.href.replace('/ui','')

    if (!this.token) {
      this.token = '<api-token>'
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue